var map = {
	"./02-2.png": "451f",
	"./02.png": "012c",
	"./ID2.png": "1797",
	"./ability/1_2.png": "b31c",
	"./ability/2_12.png": "736d",
	"./ability/2_2.png": "72c4",
	"./ability/3_2.png": "1854",
	"./ability/4_2.png": "816f",
	"./ability/5_2.png": "3ae3",
	"./android2.png": "761d",
	"./applet2.png": "eac1",
	"./block/2.png": "6b7e",
	"./card/2.png": "4c3e",
	"./chuagnjian2.png": "e5c4",
	"./game/2.png": "9330",
	"./game/swiper1_2.png": "01b3",
	"./guide/2.png": "c470",
	"./index/2-2.png": "032e",
	"./index/2.png": "df5f",
	"./index/3-2.png": "d480",
	"./index/4-2.png": "cb34",
	"./index/advert/img2.png": "8165",
	"./index/avatar2.png": "ff77",
	"./index/b2c-mall/img2.png": "2e65",
	"./index/banner/banner2.png": "b3bd",
	"./index/bg2.png": "293e",
	"./index/block-chain/img2.png": "84aa",
	"./index/card/img2.png": "f938",
	"./index/chat-gpt/img2.png": "7c2c",
	"./index/cloud-issuance/img2.png": "6f5d",
	"./index/game/card2.png": "fe1d",
	"./index/game/img2.png": "fc6a9",
	"./index/guide/func2.png": "f13d",
	"./index/icons/12.png": "edaa",
	"./index/icons/2.png": "6a6e",
	"./index/icons/IMG_1262.png": "8b40",
	"./index/icons/IMG_1266 2.png": "fa02",
	"./index/icons/IMG_1267 2.png": "147d",
	"./index/icons/IMG_1268 2.png": "d302",
	"./index/icons/icon2.png": "6bce",
	"./index/im/img2.png": "cf8d",
	"./index/life/img2.png": "2f60",
	"./index/live-video/img2.png": "4727",
	"./index/live-video/library2.png": "4638",
	"./index/logo-title2.png": "d017",
	"./index/logo2.png": "4930d",
	"./index/mall/banner2.png": "3fb2",
	"./index/mall/img2.png": "94c2",
	"./index/mall/show2.png": "7a12",
	"./index/member-mall/img2.png": "ce1a",
	"./index/o2o-mall/banner2.png": "8139",
	"./index/o2o-mall/img2.png": "6d7a",
	"./index/order/img2.png": "3711",
	"./index/pengyou2.png": "6b3f",
	"./index/phone2.png": "6b31",
	"./index/qr-code-2.png": "92ca",
	"./index/scm/img12.png": "37e9",
	"./index/scm/img2.png": "bd73",
	"./index/scm/show2.png": "aac8",
	"./index/short-play/img2.png": "0d023",
	"./index/takeaway/img2.png": "e799",
	"./index/team-selection/img2.png": "469e",
	"./index/travel/img2.png": "0947",
	"./index/weichat-2.png": "5471",
	"./institution/2.png": "80b3",
	"./ios2.png": "5917",
	"./live-video/2.png": "4441",
	"./live-video/bg2.png": "b417",
	"./live-video/icon2.png": "9709",
	"./live-video/swiper1_2.png": "4ab0",
	"./live-video/swiper2_2.png": "8d60",
	"./local/2.png": "7ba9",
	"./mall/2.png": "8092",
	"./mall/fg2.png": "4e57",
	"./mall/step_1_2.png": "5a8e",
	"./mall/step_2_2.png": "c3c6",
	"./mall/step_3_2.png": "31b4",
	"./mokuai2.png": "caa1",
	"./more-mall/2.png": "6837",
	"./o2o/2.png": "5c16",
	"./o2o/bg2.png": "2519",
	"./o2o/fg3_2.png": "282c",
	"./o2o/fg4_2.png": "1f5c",
	"./o2o/step_1_2.png": "95d2",
	"./o2o/step_2_2.png": "4bae",
	"./o2o/step_3_2.png": "48a1",
	"./o2o/step_4_2.png": "e85e",
	"./provider/2.png": "c0a0",
	"./provider/fg2.png": "e249",
	"./provider/step_1_2.png": "a031",
	"./provider/step_2_2.png": "0720",
	"./provider/step_3_2.png": "db1c",
	"./provider/step_4_2.png": "57ed",
	"./recommend/2.png": "fb59",
	"./recommend/bg2.png": "8386",
	"./web2.png": "4bbc"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5b93";